import { useDispatch, useSelector } from "react-redux";
import api from "./TokenRefreshManager";
import { SendMessageToServerSignalR } from "../../AppSystem/Helpers/SignalRClient";
import { eventHandler } from "../../AppSystem/Helpers/eventHandler";


const useApiCallService = () => {
    const dispatch = useDispatch();
    const { userData } = useSelector(state => state.auth);

    const ApiCall = async (apiCallOptions, setApiResponse, setErrorMessage = null) => {

        async function waitForMessage(userId) {
            return new Promise((resolve, reject) => {
                const timeoutDuration = 10000;
                let timeout;
                const listener = response => {
                    clearTimeout(timeout);
                    resolve(response);
                };

                timeout = setTimeout(() => {
                    eventHandler.off('ProcessUpdates', listener);
                    reject(new Error('Timeout waiting for message'));
                }, timeoutDuration);

                eventHandler.once('ProcessUpdates', listener);

                SendMessageToServerSignalR("", userId, dispatch);
            });
        }

        if (apiCallOptions.url.includes('/org/select-org') && apiCallOptions.method.toLowerCase() === 'post') {
            try {
                const userId = userData.id;
                await waitForMessage(userId);
            } catch (error) {
                console.log('Error entering connection id:', error);
                return;
            }
        }

        let contentType = 'application/json';
        if (apiCallOptions.dataTypes === 'file') contentType = 'multipart/form-Data';
        if (apiCallOptions.dataTypes === 'blob') contentType = apiCallOptions.dataTypes;

        let timeoutDuration = 120000; // 2 minutes by default

        // If the URL contains "search" or "filter", use long timeout
        if (apiCallOptions.url.includes('/search') ||
            apiCallOptions.url.includes('/filter') ||
            apiCallOptions.url.includes('economic-report')) {
            timeoutDuration = 600000; // 10 minutes
        }

        const config = {
            responseType: apiCallOptions.responseType || 'json',
            timeout: timeoutDuration,
            headers: {
                'Content-Type': contentType,
            },
        };

        let axiosCall;
        const url = apiCallOptions.url;
        const data = apiCallOptions.data;

        switch (apiCallOptions.method.toLowerCase()) {
            case 'get':
                axiosCall = api.get(url, config);
                break;
            case 'post':
                axiosCall = api.post(url, data, config);
                break;
            case 'put':
                axiosCall = api.put(url, data, config);
                break;
            case 'delete':
                axiosCall = api.delete(url, { data, ...config });
                break;
            default:
                break;
        }

        try {
            const tempResponse = await axiosCall;
            setApiResponse(tempResponse.data);
        } catch (error) {
            // The interceptor has already handled the 401 (refresh or logout)
            // Here we only handle the final error for the UI
            setApiResponse(null);
            if (setErrorMessage !== null) {
                setErrorMessage(error?.response?.data?.title || 'Error');
            }
        }
    };

    return { ApiCall };
};

export default useApiCallService;